module.exports = __webpack_public_path__ + "img/ks_title2.a47606ee.jpg";